import { AbstractFormArgument, AbstractSearchArgument } from './global'

class SearchArgument {
  constructor () {
    this.pid = ''
  }
}

class FormArgument extends AbstractFormArgument {
  constructor () {
    super()

    this.pid = ''
    this.title = ''
  }
}

class FeedbackSearchArgument extends AbstractSearchArgument {
  constructor () {
    super()

    this.startTime = ''
    this.endTime = ''
  }
}

export {
  FeedbackSearchArgument,
  SearchArgument,
  FormArgument
}



// WEBPACK FOOTER //
// ./src/models/system-department.js